import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import UserService from "services/UserService";
import axios from "axios";
import { getMBMEquipments, putMBMEquipments } from "services/ConfigServices";
import { equipmenttext } from "variables/MBM/equipments";
import { definitionData, fieldprotocoleData, eosprotocoleData, hardwareData } from "variables/MBM/lists/equipments";
import { NotificationManager } from "react-notifications";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "5px",
    marginLeft: "0.5rem",
    width: "30ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "5px",
    marginLeft: "0.5rem",
    width: "30ch",
  }
}));

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const EquipmentDetails = styled.div`
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const EquipmentButton = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
cursor: pointer;
`;

export default function useEquipmentsTable(wpgroup, workspace) {
  const classes = useStyles();
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbm_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMEquipments(wpgroup, 'false', 'true');
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [equipmentsdata, setEquipmentsData] = useState([]);
  const [displaymethod, setDisplaymethod] = useState("equipments");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (wpgroup && wpgroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === wpgroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        // setResults(response.data);
        // setEquipmentsData(response.data.equipments);
        setEquipmentsData(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = wpgroup;
      fetchData();
    }
  }, [wpgroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const handleDisplaymethodChange = (event) => { setDisplaymethod(event.target.value); };

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const handleSubmit = (event) => {
    setButtonDisabled(true);
    axios
      .put(
        putMBMEquipments("updategeb"),
        {
          equipments: equipmentsdata.equipments
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Enregistrement réussi");
          refreshTable();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };
  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };



  const filteredItemsEquipments = _.get(equipmentsdata, `equipments`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.definition && definitionData.find((x) => x.id == item.definition) && definitionData.find((x) => x.id == item.definition).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.connectionproperties?.eosprotocol && eosprotocoleData.find((x) => x.id == item.connectionproperties.eosprotocol) && eosprotocoleData.find((x) => x.id == item.connectionproperties.eosprotocol).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.otherproperties?.hardware && hardwareData.find((x) => x.id == item.otherproperties.hardware) && hardwareData.find((x) => x.id == item.otherproperties.hardware).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.connectionproperties?.fieldProtocol && fieldprotocoleData.find((x) => x.id == item.connectionproperties.fieldProtocol) && fieldprotocoleData.find((x) => x.id == item.connectionproperties.fieldProtocol).name.toLowerCase().includes(filterText.toLowerCase()))

  )
    ;

  const handleSelectAll = () => {
    filteredItemsEquipments.forEach((filteq) => {
      if (!filteq.otherproperties?.workspaces?.find((w) => w.id === workspace.id)) {
        if (!filteq.otherproperties)
          filteq.otherproperties = {};
        if (!filteq.otherproperties.workspaces)
          filteq.otherproperties.workspaces = [];
        filteq.otherproperties.workspaces.push({ id: workspace.id });
      }
    })
    setEquipmentsData({ ...equipmentsdata });
    setButtonDisabled(false);
  }

  const handleUnselectAll = () => {
    filteredItemsEquipments.forEach((filteq) => {
      if (filteq.otherproperties?.workspaces?.find((w) => w.id === workspace.id)) {
        filteq.otherproperties.workspaces = filteq.otherproperties.workspaces.filter((w) => w.id !== workspace.id);
      }
    })
    setEquipmentsData({ ...equipmentsdata });
    setButtonDisabled(false);
  }

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);

    return (

      <>

        <TableName>{equipmenttext.includedequipments}</TableName>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        <EquipmentDetails>
          <EquipmentButton onClick={handleSelectAll}>{equipmenttext.selectall}</EquipmentButton>
          <EquipmentButton onClick={handleUnselectAll}>{equipmenttext.unselectall}</EquipmentButton>
        </EquipmentDetails>
        <>
          <Button
            disabled={buttonDisabled}
            className={
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
            }
            onClick={() => {
              handleSubmit();
            }}
          >
            Enregistrer
          </Button>
        </>
      </>
    );
  }, [filterText, resetPaginationToggle, equipmentsdata, displaymethod]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItemsEquipments,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setEquipmentsData,
    equipmentsdata,
    setButtonDisabled,
    displaymethod
  };
}
